<template>
  <div v-if="count > 0"
       class="play-count-component"
  >
    <div class="block">
      <ym-icon name="round-play" />
      <span>{{ count }}</span>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'PlayCountComponent',
    props: {
      count: {
        type: Number,
        default: 0,
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .play-count-component {
    width: 100%;
    height: @size-large;
    padding-bottom: @size-extra-small;
    padding-left: @size-base;
    box-sizing: border-box;
    display: flex;
    align-items: flex-end;
    background: linear-gradient(360deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.2) 100%);
    color: @color-white;
  }
  .block {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .round-play {
    margin-right: @size-extra-small;
    font-size: @font-size-small;
  }
  span {
    display: block;
    margin-left: @size-extra-small;
    font-size: @font-size-small;
    line-height: 1;
  }

</style>
